import './Score.css'

const Score = ({ match }) => {
  return (
    <div className="score">
      <p>
        {match.match_home_score} - {match.match_away_score}
      </p>
      {match.match_home_penalty_score && match.match_away_penalty_score && (
        <p className="penalties">
          ({match.match_home_penalty_score} - {match.match_away_penalty_score}{' '}
          on pens)
        </p>
      )}
    </div>
  )
}

export default Score
